<!--
TODO
Moveable

evtl https://github.com/mauricius/vue-draggable-resizable

-->
<template>
<v-flex style="height: 100%;">
  <v-card class="window elevation-5" ref="window" v-bind:class="{'infs':(infs||$vuetify.breakpoint.smAndDown),'distrans':(armed!=false)}" style="height:100%">
    <div @mousedown="movestart">
      <v-system-bar :title="head" window dark class="windowtitle" v-on:dblclick.native="makeBig" v-if="!$vuetify.breakpoint.smAndDown">
        <img alt="" src="https://wuerfeldev.de/favicon.ico"> &nbsp;
        <!--<v-spacer></v-spacer>-->
        {{head}}
        <v-spacer></v-spacer>

        <span style="position:absolute;right:0px;" title="">
        <v-icon class="windowctrl" @click="hideWindow">minimize</v-icon>
        <v-icon v-if="infs" class="windowctrl" @click="makeBig">filter_none</v-icon>
        <v-icon v-else="" class="windowctrl" @click="makeBig">check_box_outline_blank</v-icon>
        <v-icon class="windowctrl" @click="closeWindow">close</v-icon>
      </span>
      </v-system-bar>
    </div>
    <div class="realcontent" v-bind:class="{'mobilecontent':$vuetify.breakpoint.smAndDown}">
      <transition name="fade" mode="out-in">
        <slot/>
      </transition>

    </div>
  </v-card>
</v-flex>
</template>

<script>
export default {
  name: "AppWindow",
  data() {
    return {
      armed: false
    }
  },
  props: {
    head: {
      default: ""
    },
    infs: {
      default: false
    }
  },
  methods: {
    move(e) {
      if (this.armed != false && !this.infs) {

        // calc position
        var ntop = e.clientY - document.getElementById("content").getBoundingClientRect().top - this.armed[0];
        var nleft = e.clientX - document.getElementById("content").getBoundingClientRect().left - this.armed[1];

        // validate its range
        if(ntop<0){
          ntop = 0;
        }
        var nntop = document.getElementById("content").getBoundingClientRect().bottom - this.$refs.window.$el.getBoundingClientRect().height - document.getElementById("content").getBoundingClientRect().top;
        if(ntop>nntop){
          ntop = nntop;
        }

        if(nleft<0){
          nleft = 0;
        }
        var nnleft = document.getElementById("content").getBoundingClientRect().right - this.$refs.window.$el.getBoundingClientRect().width - document.getElementById("content").getBoundingClientRect().left;
        if(nleft>nnleft){
          nleft = nnleft;
        }

        // set position
        this.$refs.window.$el.style.top = ntop + "px";
        this.$refs.window.$el.style.left = nleft + "px";
      }
    },
    movestop() {
      document.documentElement.removeEventListener('mousemove', this.move, true);
      this.armed = false;
    },
    movestart(e) {
      if (!this.infs) {
        this.armed = Array(e.clientY - e.currentTarget.getBoundingClientRect().top, e.clientX - e.currentTarget.getBoundingClientRect().left);
        document.documentElement.addEventListener('mousemove', this.move, true);
      }
    },
    makeBig() {
      this.$emit('tfs');
    },
    hideWindow() {
      // this.$router.push('/')
      this.closeWindow();
    },
    closeWindow() {
      this.$router.push('/desktop')
    }
  },
  mounted: function() {
    document.documentElement.addEventListener('mouseup', this.movestop, true);
  },
  beforeDestroy: function() {
    document.documentElement.removeEventListener('mouseup', this.movestop, true);
  }
}
</script>
<style>

.fade-enter-active,
.fade-leave-active {
  transition: all .1s;
}

/* .fade-leave-active below version 2.1.8 */

.fade-enter,
.fade-leave-to {
  opacity: 0;
}





.windowtitle {
  background-color: #222D32 !important;
  border-radius: 0px;
  cursor: default;
  /* position: sticky; */
  top: 0px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -ms-user-select: none;
}

.window {
  /* border: 2px solid #222D32; */
  border-radius: 0px;
  background-color: white;
  position: absolute;
  max-height: 80%;
  overflow: hidden;
  top: 10%;
  /* margin-right: 10%;
  margin-left: 10%; */
  width: 80%;
  left: 10%;

  transition: all 0.5s ease;
}

.distrans{
  transition: none;
}

.window.infs {
  height: 100% !important;
  top: 0% !important;
  /* margin-right: 0%;
  margin-left: 0%; */
  left: 0% !important;
  width: 100%;
  max-height: 100%;
}

.windowctrl {
  cursor: pointer;
}

.realcontent {
  position: relative;
  overflow: auto;
  width: 100%;
  height: calc( 100% - 32px);
}

.realcontent.mobilecontent {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/AppWindow.vue